import { useState, useEffect } from 'react'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'
import { formatDate, getAllData, subtractDays } from '../../../shared/constants'

const ContentReport = () => {
  const [state, setState] = useState({
    data: [],
    loading: false,
    paginate: false,
    downloadData: false,
  })

  const filterData = state.data
  const [page, setPage] = useState(1)

  //? useEffect
  useEffect(() => {
    getAllData('GET_CONTENT_REPORT', { page: page, limit: 10 }, state, setState)
  }, [page])

  const handleChange = (event, value) => {
    setPage(value)
  }

  let tableBody = []

  console.log({ filterData })
  console.log({ state })

  if (!state.loading && filterData.length > 0) {
    tableBody = filterData.map((item) => {
      return [{ value: item.category }, { value: item.contentType }, { value: item.startDate }, { value: item.expiryDate == '' ? 'N/A' : item.expiryDate }, { value: item.totalQuiz }]
    })
  }

  const layoutProps = {
    heading: 'Content Report',
    filename: 'contentReport',
    headers: state.downloadData.headings,
    data: state.downloadData.headingValues,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Category', 'Content Type', 'Start Date', 'End Date', 'Quiz']}
      loading={state.loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: state.paginate.totalPage, page: page }}
      layoutProps={layoutProps}
    />
  )
}

export default ContentReport
